export enum FormStatus {
    INIT = 'INIT',
    INVALID = 'INVALID',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
}
